import { RemoteLoadWorkFinishOptionList } from '@/javascript/data/usecases'
import { LoadWorkFinishOptionList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadWorkFinishOptionList = (): LoadWorkFinishOptionList =>
  new RemoteLoadWorkFinishOptionList(makeApiUrl('/work_finish_options'), makeCurrentAccountHttpClientDecorator())